import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { ErrorState, Button } from '@/design-system/primitives';

export class RouteErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) console.error('Page rendering failed', error, info);
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return <section data-testid="route-error-boundary">
      <ErrorState title="تعذر عرض هذه الصفحة" description="حدث خطأ أثناء عرض الصفحة. يمكنك إعادة المحاولة أو إعادة تحميل التطبيق." retry={() => this.setState({ failed: false })} />
      <Button onClick={() => window.location.reload()}>إعادة تحميل التطبيق</Button>
    </section>;
  }
}
